import { Typography } from '@mui/material';
import { useRef } from 'react';
import { useTwoLineEllipsis } from '../../utils/useTwoLineEllipsis';
import Pill from '../common/Pill';

interface Props {
  title: string;
  trending?: boolean;
  tags: any;
  thumbnailSnippet: string;
  className?: string;
  isMobile?: boolean;
  isTablet?: boolean;
}
const defaultClass = 'border hover:cursor-pointer bg-light-blue h-7';
const fontFamily = 'var(--fontBase)';

function ArticleThumbnailContent(props: Props) {
  const { title, trending = false, tags, thumbnailSnippet, className = 'mt-1', isMobile, isTablet } = props;
  const renderTag = tags.length > 0;
  const shortenedThumnbnailSnippet = thumbnailSnippet ? `${thumbnailSnippet}...` : null;
  const textRef = useRef<HTMLDivElement>(null);
  useTwoLineEllipsis(textRef, 20, 2); // 20px line height, 2 lines

  const tagOrderMap: { [key: string]: string } = {
    'Web Development': 'Web Dev',
    'Mobile App Development': 'Mobile Dev',
    'UI/UX Design': 'UI/UX Design',
    'Latest Technologies': 'Latest Tech',
    'Digital Marketing': 'Digital Marketing',
    'Software Development': 'Software Dev',
  };

  const getTitleFontSize = () => {
    if (isMobile) return trending ? '14px' : '16px';
    if (isTablet) return trending ? '16px' : '18px';
    return trending ? '17px' : '20px';
  };

  const sortedTags = Object.keys(tagOrderMap).filter((key) => tags.includes(key));

  return (
    <>
      <div className="breaktwo:hidden flex flex-wrap gap-2">
        {renderTag &&
          sortedTags.map((tag: string) => (
            <Pill
              key={tag}
              containerClasses={defaultClass}
              typographyStyles={{ color: 'block', fontSize: 12, padding: '10px' }}>
              {tagOrderMap[tag]}
            </Pill>
          ))}
      </div>
      <div className={className}>
        <Typography
          className="line-clamp-3"
          variant="subinformation"
          style={{
            color: 'black',
            fontFamily,
            fontSize: trending ? '13px' : '16px',
            lineHeight: '1.3',
          }}>
          {title}
        </Typography>
      </div>
      <div className="flex justify-between items-center text-gray-400 text-sm mt-1" ref={textRef}>
        <Typography
          variant="h6"
          style={{
            fontFamily: 'var(--fontPrimary)',
            fontSize: trending ? '13px' : '14px',
            lineHeight: '1.4',
            color: trending ? '#666' : '#777',
          }}>
          {shortenedThumnbnailSnippet}
        </Typography>
      </div>
    </>
  );
}

export default ArticleThumbnailContent;
